import React from 'react';

function Money() {
  /* eslint-disable max-len */
  return (
    <svg width="84" height="84" viewBox="0 0 84 84" xmlns="http://www.w3.org/2000/svg">
      <g fill="#FFF" fillRule="evenodd">
        <path
          d="M42 83.5C19.08 83.5.5 64.92.5 42S19.08.5 42 .5 83.5 19.08 83.5 42 64.92 83.5 42 83.5zm0-3c21.263 0 38.5-17.237 38.5-38.5S63.263 3.5 42 3.5 3.5 20.737 3.5 42 20.737 80.5 42 80.5z"
          fillRule="nonzero"
        />
        <path d="M42.458 39.75c-5.575-1.475-7.368-3-7.368-5.375 0-2.725 2.48-4.625 6.63-4.625 4.372 0 5.993 2.125 6.14 5.25h5.428c-.172-4.3-2.75-8.25-7.883-9.525V20h-7.368v5.4c-4.764 1.05-8.595 4.2-8.595 9.025 0 5.775 4.69 8.65 11.542 10.325 6.14 1.5 7.368 3.7 7.368 6.025 0 1.725-1.204 4.475-6.63 4.475-5.06 0-7.05-2.3-7.32-5.25H29c.295 5.475 4.322 8.55 9.037 9.575V65h7.368v-5.375C50.195 58.7 54 55.875 54 50.75c0-7.1-5.968-9.525-11.542-11z" />
      </g>
    </svg>
  );
  /* eslint-enable */
}

export default Money;



// WEBPACK FOOTER //
// ./src/common/icons/Money.js